module.exports = __webpack_public_path__ + "img/tools-voting.9bef1b02.png";